import { useSelector } from "react-redux";
import { useFeature } from "./useFeature.js";
import searchSelectors from "../redux/selectors/searchSelectors.js";
import { AppFeatures } from "../constants/featureFlags.js";
import { PageContextUtils } from "../utils/index.js";
import { ClientProviderEnum } from "../constants/index.js";

export const useSearchEnabled = () => {
  const searchSettings = useSelector(searchSelectors.settings);
  const isKambiSearchEnabled = useFeature(AppFeatures.KAMBI_SEARCH);
  const searchStateByProvider = {
    [ClientProviderEnum.Spectate]: searchSettings?.enabled,
    [ClientProviderEnum.Kambi]: isKambiSearchEnabled
  };
  const { name } = PageContextUtils.getClientProviderData();
  return searchStateByProvider[name] || false;
};
